import ApiService from "../apiService";
import { get, patch, post, destroy } from "../apiService";

const model = "treatment-codes";
export default class TreatmentCodeService extends ApiService {
  findAll(searchTerm) {
    return get(`/${model}`, {
      params: {
        "filter[search]": searchTerm
      }
    });
  }

  save(item) {
    return this.baseSave(model, item);
  }

  archive(item) {
    delete item["links"];
    delete item["attributes"];
    return destroy(`/${model}/${item.id}`, { data: item });
  }
}



// WEBPACK FOOTER //
// ./src/services/treatmentCodeService/index.js